import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { ICreateEmployeeExitRequest, IEmployeeExit } from '../interfaces/payroll.interface';

// Employee exit lifecycle (spec §2.4). Create/list are institution-scoped; delete (undo) is keyed
// off the exit id, with institutionId passed as a query param (§2.0 tenancy assert pairing).
export const EmployeeExitService = {
    create: async (
        data: ICreateEmployeeExitRequest,
        institutionId: string
    ): Promise<IEmployeeExit> => {
        const response = await axios.post(ENDPOINTS.EMPLOYEE_EXIT.BASE(institutionId), data, {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    list: async (institutionId: string): Promise<IEmployeeExit[]> => {
        const response = await axios.get(ENDPOINTS.EMPLOYEE_EXIT.BASE(institutionId), {
            headers: AuthService.getAuthHeader(),
        });
        return response.data;
    },

    delete: async (id: string, institutionId: string): Promise<void> => {
        await axios.delete(ENDPOINTS.EMPLOYEE_EXIT.DELETE(id, institutionId), {
            headers: AuthService.getAuthHeader(),
        });
    },
};
